export const PRIVATE_KEY_STORAGE_ID = 'privateKey';
export const GET_TALKING_POINTS_QUERY_KEY = 'talking-points';
